module.exports = __webpack_public_path__ + "img/wheat_nss1425.1e02701a.jpg";